import RotatingText from './RotatingText'


export default RotatingText
